var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgReduce(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    fill: "none",
    viewBox: "0 0 30 30",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "expand"
  }, /*#__PURE__*/React.createElement("g", {
    stroke: "#263945",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.4584
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "m23.491 13.059-6.5465-0.003474-0.017087-6.0316"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m23.75 6.25-6.8056 6.8059"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m6.8649 16.922 6.1907 0.021594-0.010346 5.6964"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m6.25 23.749 6.8056-6.8058"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReduce);
export default __webpack_public_path__ + "static/media/reduce.fff015eb9e9648ea92c8b1d3c4042f5d.svg";
export { ForwardRef as ReactComponent };